import apiService from './apiService';

export interface DomainResultItem {
  domain: string;
  category: string | null;
  is_favorite: boolean;
  created_at: string;
}

export interface DomainCategory {
  id: string;
  name: string;
  description: string | null;
  last_description: string | null;
}

export interface DomainTaskStatus {
  domains: string[];
  done: boolean;
  status_messages: string[];
  category: string | null;
}

export interface StartGenerationParams {
  description: string;
  tlds: string;
  max_length: number;
  quantity_needed: number;
  category?: string;
}

export const startDomainGeneration = async (data: StartGenerationParams) => {
  const res = await apiService.post<{ task_id: string }>('/api/domains/generate', data);
  return res.data;
};

export const getDomainTaskStatus = async (taskId: string) => {
  const res = await apiService.get<DomainTaskStatus>(`/api/domains/status/${taskId}`);
  return res.data;
};

export const stopDomainGeneration = async () => {
  const res = await apiService.post<{ success: boolean; stopped_count: number }>(
    '/api/domains/stop',
    {}
  );
  return res.data;
};

export const getDomainResults = async () => {
  const res = await apiService.get<{
    status: string;
    domains: DomainResultItem[];
    count: number;
  }>('/api/domains/results');
  return res.data;
};

export const deleteDomain = async (domain: string) => {
  const res = await apiService.post<{ status: string }>('/api/domains/delete', { domain });
  return res.data;
};

export const updateDomainsCategory = async (domains: string[], category: string) => {
  const res = await apiService.post<{ status: string; updated_count: number }>(
    '/api/domains/update-category',
    { domains, category }
  );
  return res.data;
};

export const removeNonFavoriteDomains = async (category?: string | null) => {
  const res = await apiService.post<{ status: string; removed_count: number }>(
    '/api/domains/remove-non-favorites',
    { category: category ?? null }
  );
  return res.data;
};

export const addDomainFavorite = async (domain: string, category?: string) => {
  const res = await apiService.post<{ status: string }>('/api/domains/favorites', {
    domain,
    category,
  });
  return res.data;
};

export const removeDomainFavorite = async (domain: string) => {
  const res = await apiService.delete<{ status: string }>('/api/domains/favorites', {
    data: { domain },
  });
  return res.data;
};

export const getDomainCategories = async () => {
  const res = await apiService.get<{ status: string; categories: DomainCategory[] }>(
    '/api/domains/categories'
  );
  return res.data;
};

export const createDomainCategory = async (name: string) => {
  const res = await apiService.post<{ status: string; id: string }>('/api/domains/categories', {
    name,
  });
  return res.data;
};

export const renameDomainCategory = async (categoryId: string, name: string) => {
  const res = await apiService.patch<{ status: string; updated_domains: number }>(
    `/api/domains/categories/${categoryId}`,
    { name }
  );
  return res.data;
};

export const deleteDomainCategory = async (categoryId: string) => {
  const res = await apiService.delete<{ status: string }>(
    `/api/domains/categories/${categoryId}`
  );
  return res.data;
};
